import { Box, Button, Container, Divider, Grid, Toolbar} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ModalUnstyled } from "../modal/Modal";
import { StoreCard } from "../components/StoreCard";
import { useLocalStorage } from "../hooks/useLocalStorage";
import MultiStepForm from "../Forms/MultiStepPayFrom";
import Footer from "./homepage/components/Footer";
import { AppBar, Typography } from "@mui/material";


export const StoreSelect = () => {
    const { user, listStore, updateStoreList } = useAuth();
    const [showModaladd1, setshowModaladd1] = useState(false);
   

    const [da, setda] = useLocalStorage('da', null);
    const [, setStore] = useLocalStorage('ds', null);
    const navigate = useNavigate();
    // this is comming soon
    // const [showModaljoin, setshowModaljoin] = useState(false); 

    /// 0 -> admin.
    /// 1 -> manager.
    /// 2 -> basic user.


    useEffect(() => {
        if (!user) {
            navigate("/login", { replace: true })
        }
        console.log(da);
        if (da >= 0 && da !== null) {
            navigate("/admin", { replace: true })
        }
        updateStoreList();
        // eslint-disable-next-line
    }, [da, user, navigate]);

    const cardActionHandler = async (type, storeid) => {
        setda(type);
        await setStore(storeid);
        if (da >= 0) {
            navigate("/admin", { replace: true })
        }
    }

    return (
        <>

            <AppBar  sx={{ background: '#1a1b2f'}} elevation={2}>
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Typography variant="h6" onClick={()=>{ navigate("/")}}>MiiRA POS</Typography>
                   
                        <Box>
                           
                            <Button sx={{ background: 'tomato', color: '#fff', px: 2, py: 1 }} 
                            // key={'Logout-0'} onClick={() => Logout()}
                            >
                                LogOut
                            </Button>
                        </Box>
                    
                </Toolbar>
            </AppBar>

            <Container sx={{marginTop:'80px'}}>
                <Box>
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={8}>
                            <h3>STORE LIST</h3>
                        </Grid>
                        <Grid item xs={6} md={4} justifyItems={"end"}>
                            <Button variant="contained" sx={{ margin: "3px" }}
                                onClick={() => {
                                    setshowModaladd1((prev) => !prev);
                                }}
                            >+ Add Store</Button>&nbsp;&nbsp;

                            {/* Wait for next Update Once Email server is setup.... */}
                            {/* <Button variant="outlined" sx={{ margin: "3px" }} >
                            Join Existing
                        </Button> */}
                        </Grid>
                    </Grid>
                </Box>
                <Box>
                    <Divider sx={{ marginBottom: "15px" }} />
                    <Grid container spacing={2} >
                        <>
                            {
                                (listStore.length > 0) ? listStore.map((store) => (<StoreCard key={'ss' + store.storeid} storeName={store.name} storeid={store.storeid} type={store.type} address={store.address} setda={setda} setStore={setStore} cardActionHandler={cardActionHandler} />)) : "NO Data From Server"
                            }
                        </>
                    </Grid>
                </Box>
                <ModalUnstyled
                    shouldShow={showModaladd1}
                    onRequestClose={() => {
                        setshowModaladd1((prev) => !prev);
                    }}
                >
                    <MultiStepForm setshowModaladd={setshowModaladd1} />
                </ModalUnstyled>
            </Container>
            <Box sx={{ position: "absolute", width: '100%', left: '0', bottom: '0' }}>
                <Footer></Footer>

            </Box>

        </>
    );
}